import { render, staticRenderFns } from "./PhoneTypeSetting.vue?vue&type=template&id=55cbc51c"
import script from "./PhoneTypeSetting.vue?vue&type=script&lang=js"
export * from "./PhoneTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports